// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* style-for-Profile-chart */
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.profile_types {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 34px;
  height: 15px;
  margin-left: 6px;
}

.profile-2x .profile_types {
  transform: scale(1.6);
}

.accelerator,
.profile_types-7 {
  background-position: -35px 0 !important;
}

.analyst,
.profile_types-6 {
  background-position: 0 -31px !important;
}

.clarifier,
.profile_types-1 {
  background-position: -70px -31px !important;
}

.developer,
.profile_types-3 {
  background-position: -140px -16px !important;
}

.developer-bg {
  background-color: rgb(105, 190, 40) !important;
}

.ideator-bg {
  background-color: rgb(255, 121, 0) !important;
}

.clarifier-bg {
  background-color: rgb(0, 173, 208) !important;
}

.implementer-bg {
  background-color: rgb(245, 67, 89) !important;
}

.driver,
.profile_types-9 {
  background-position: -70px 0 !important;
}

.early-bird,
.profile_types-5 {
  background-position: -70px -15.6px !important;
}

.finisher,
.profile_types-10 {
  background-position: -140px 0 !important;
}

.hare,
.profile_types-11 {
  background-position: -105px -31px !important;
}

.idea-broker,
.profile_types-12 {
  background-position: -105px 1px !important;
}

.ideator,
.profile_types-2 {
  background-position: 0 -16px !important;
}

.implementer,
.profile_types-4 {
  background-position: -35px -15.8px !important;
}

.integrator,
.profile_types-14 {
  background-position: -140px -32px !important;
  margin-top: 5px;
}

.optimist,
.profile_types-13 {
  background-position: -35px -31px !important;
}

.realist,
.profile_types-15 {
  background-position: -104.8px -15px !important;
}

.theorist,
.profile_types-8 {
  background-position: 0 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fs-icon/fs-icon.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,4BAAA;ACgIA;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA7YA;EAEE,6GAAA;EACA,6BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA+YF;;AA3YE;EACE,qBAAA;AA8YJ;;AAzYA;;EAEE,uCAAA;AA4YF;;AAzYA;;EAEE,uCAAA;AA4YF;;AAzYA;;EAEE,2CAAA;AA4YF;;AAzYA;;EAEE,4CAAA;AA4YF;;AAzYA;EACE,8CAAA;AA4YF;;AAzYA;EACE,6CAAA;AA4YF;;AAzYA;EACE,6CAAA;AA4YF;;AAzYA;EACE,6CAAA;AA4YF;;AAzYA;;EAEE,uCAAA;AA4YF;;AAzYA;;EAEE,6CAAA;AA4YF;;AAzYA;;EAEE,wCAAA;AA4YF;;AAzYA;;EAEE,4CAAA;AA4YF;;AAzYA;;EAEE,0CAAA;AA4YF;;AAzYA;;EAEE,uCAAA;AA4YF;;AAzYA;;EAEE,6CAAA;AA4YF;;AAzYA;;EAEE,4CAAA;EACA,eAAA;AA4YF;;AAzYA;;EAEE,2CAAA;AA4YF;;AAzYA;;EAEE,8CAAA;AA4YF;;AAzYA;;EAEE,mCAAA;AA4YF","sourcesContent":["/* style-for-Profile-chart */\n@import './../../../assets/styles/variables';\n\n.profile_types {\n  //background-image: url($assets+\"/images/foursight-profile-types.png\") !important;\n  background-image: url($assets+\"/images/foursight-profile-types.svg\") !important;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  width: 34px;\n  height: 15px;\n  margin-left: 6px;\n  //background-size: 175px 46px;\n}\n.profile-2x{\n  .profile_types{\n    transform: scale(1.6);\n  }\n}\n\n// all profile ids\n.accelerator,\n.profile_types-7 {\n  background-position: -35px 0 !important;\n}\n\n.analyst,\n.profile_types-6 {\n  background-position: 0 -31px !important;\n}\n\n.clarifier,\n.profile_types-1{\n  background-position: -70px -31px !important;\n}\n\n.developer,\n.profile_types-3 {\n  background-position: -140px -16px !important;\n}\n\n.developer-bg{\n  background-color: $develop-color !important;\n}\n\n.ideator-bg{\n  background-color: $ideate-color !important;\n}\n\n.clarifier-bg{\n  background-color: $clarify-color !important;\n}\n\n.implementer-bg{\n  background-color: $implement-color !important;\n}\n\n.driver,\n.profile_types-9 {\n  background-position: -70px 0 !important;\n}\n\n.early-bird,\n.profile_types-5 {\n  background-position: -70px -15.6px !important;\n}\n\n.finisher,\n.profile_types-10 {\n  background-position: -140px 0 !important;\n}\n\n.hare,\n.profile_types-11 {\n  background-position: -105px -31px !important;\n}\n\n.idea-broker,\n.profile_types-12 {\n  background-position: -105px 1px !important;\n}\n\n.ideator,\n.profile_types-2 {\n  background-position: 0 -16px !important;\n}\n\n.implementer,\n.profile_types-4 {\n  background-position: -35px -15.8px !important;\n}\n\n.integrator,\n.profile_types-14 {\n  background-position: -140px -32px !important;\n  margin-top: 5px\n}\n\n.optimist,\n.profile_types-13 {\n  background-position: -35px -31px !important;\n}\n\n.realist,\n.profile_types-15 {\n  background-position: -104.8px -15px !important;\n}\n\n.theorist,\n.profile_types-8 {\n  background-position: 0 0 !important;\n}\n","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
